export const namespaced = true;

export const state = {
  employmentStatuses: [
    {
      id: 1,
      name: '正社員',
    },
    {
      id: 2,
      name: '非正社員',
    },
  ],
};

export const getters = {
  getEmploymentStatusById: (state) => (id) => {
    return state.employmentStatuses.find((item) => item.id == id);
  },
};
